import { connect } from 'react-redux';
import { Dispatch } from 'react';
import { IReduxRootState } from '../../../../app/reduxRootState.interface';
import { CardsActions } from '../cardsActions';
import { CardsAction } from '../cardsActionType';
import { AddressFormatter } from '../../../addresses/address/addressFormatter.service';
import { ICardPutRequest } from './card.interface';
import Card, { ICardDispatchProps, ICardOwnProps, ICardStateProps } from './Card';
import { injectIntl } from 'react-intl';

function mapStateToProps(
    { addresses: { addressesMap }, app }: IReduxRootState,
    { card }: ICardOwnProps,
) {
    let billingAddress;
    if (addressesMap && card) {
        billingAddress = addressesMap[card.addressUuid];
    }

    return {
        billingAddress: billingAddress
            ? AddressFormatter.formatToReactNode(billingAddress, false, false, true)
            : '',
        challengerPid: app.appConfig.CHALLENGER_PIDS.PAYMENTS_DEFAULT,
    };
}

function mapDispatchToProps(dispatch: Dispatch<CardsAction>) {
    return {
        deleteCard: (cardToken: string) => {
            dispatch(CardsActions.deleteCard(cardToken));
        },
        setIsPrimary: (cardToken: string, updatedCard: ICardPutRequest) => {
            dispatch(CardsActions.setIsPrimary(cardToken, updatedCard));
        },
        updateCard: (cardToken: string, updatedCard: ICardPutRequest) => {
            dispatch(CardsActions.updateCard(cardToken, updatedCard));
        },
    };
}

const CardContainer = connect<ICardStateProps, ICardDispatchProps, ICardOwnProps, IReduxRootState>(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(Card));

export default CardContainer;
